import script from "./TheTeamsForJuri.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTeamsForJuri.vue?vue&type=script&setup=true&lang=js"

import "./TheTeamsForJuri.vue?vue&type=style&index=0&id=62f41259&scoped=true&lang=css"

import exportComponent from "D:\\Работа\\vue3\\_hackatons\\latest_version\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f41259"]])

export default __exports__